import get from 'lodash/get';

import Box from '@zenbusiness/zui/Box';
import Card from '@zenbusiness/zui/Card';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const ShowCaseList = superstyled({
  tag: Card,
  name: 'ShowCaseSection',
  slot: 'ShowCaseList',
  propsNeeded: ['length'],
  styles: ({ theme, length }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: `repeat(${Math.ceil(length / 2)}, 1fr)`,
    },

    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: `repeat(${length}, 1fr)`,
    },
  }),
});

export const ShowCaseItem = superstyled({
  tag: Card,
  name: 'ShowCaseSection',
  slot: 'ShowCaseItem',
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(0),
    gap: theme.spacing(0),
    minHeight: 'fit-content',
  }),
});

export const Image = superstyled({
  tag: Stack,
  name: 'ShowCaseSection',
  slot: 'Image',
  propsNeeded: ['bgrColor'],
  styles: ({ theme, bgrColor }) => ({
    backgroundColor: bgrColor ? get(theme, bgrColor) : 'transparent',
    width: '100%',
  }),
});

export const Content = superstyled({
  tag: Box,
  name: 'ShowCaseSection',
  slot: 'Content',
  styles: ({ theme }) => ({
    flexGrow: 1,
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
    width: '100%',
    backgroundColor: theme.palette.background.grey.light,
  }),
});

export const Asset = superstyled({
  tag: SharedAsset,
  name: 'ShowCaseSection',
  slot: 'Asset',
  styles: () => ({
    objectFit: 'cover',
  }),
});
